module.exports = __webpack_public_path__ + "media/src/assets/images/lps-graph-default-b6a2dcc2dc9de3576c172242b0bda483.png";